module.exports = __webpack_public_path__ + "img/iv-stand-0-stand.e3d01697.png";